import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/authentication/_services/auth.service';
import { PricingService } from 'src/app/services/pricing.service';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';
import { LookUpService } from 'src/app/services/lookup.service';
import { environment } from 'src/environments/environment.prod';

@Component({
    selector: 'app-header-style-two',
    templateUrl: './header-style-two.component.html',
    styleUrls: ['./header-style-two.component.css'],
    standalone: false
})
export class HeaderStyleTwoComponent implements OnInit {
  token: string | null = null;
  userName: string | null = null;
  classApplied = false;
  isSticky = false;
  
  toggleClass() {
    this.classApplied = !this.classApplied;
  }
  
  classApplied2 = false;
  toggleClass2() {
    this.classApplied2 = !this.classApplied2;
  }

  classApplied3 = false;
  toggleClass3() {
    this.classApplied3 = !this.classApplied3;
  }
  youtube: string | undefined;
  twitter: string | undefined;
  linkedin: string | undefined;
  instagram: string | undefined;
  faceBook: string | undefined;
  email: string | undefined;
  logoHeader: string | undefined;
  footerImageScharfesicht: string | undefined;
  download_Url_Android: string | undefined;
  download_Url_Huawei: string | undefined;
  download_Url_Ios: string | undefined;
  footer_Text: string | undefined;
  footer_TextScharfesicht: string | undefined;
  homePage_Section8: string | undefined;
  packagesCount: number =0;
  sidebarLogo: string = 'https://lamadrivingschool.com/assets/logo.png';
  constructor(public authService: AuthenticationService, public pricingService: PricingService, public lookupService: LookUpService
  ) { }

  ngOnInit(): void {
    this.lookupService.getAll$().subscribe(lookups => {
      if (lookups) {
        const logoSetting = lookups.find((x: any) => x?.name == "LogoHeader");
        if (logoSetting && logoSetting.value) {
          const imgUrl = this.createImgPath(logoSetting.value);
          if (imgUrl) {
             this.sidebarLogo = imgUrl;
          }
        }
      }
    });
    this.token = localStorage.getItem('token');
    this.userName = localStorage.getItem('userName');
    this.pricingService.getAllUserPayments$(false).subscribe(x => {
      this.packagesCount = x.length
    });
    
    // Add scroll event listener for sticky header
    window.addEventListener('scroll', () => {
      this.isSticky = window.scrollY > 100;
    });
  }
  // openSocalMediaNewWindow(id: string | undefined) {
  //   this.service.openSocalMediaNewWindow(id);
  // }
  createImgPath = (serverPath: string) => {
    if (serverPath)
      return `${environment.patchUrl}/${serverPath}`;
  }

  logout() {

    this.authService.logout();
  }

}

